// components/StockTables/PurchaseStockTable.jsx
import React from 'react';
import _ from 'lodash'; // ตรวจสอบให้แน่ใจว่ามีการ import lodash

const PurchaseStockTable = ({ data }) => {
  // 1. กรองข้อมูลเฉพาะรายการซื้อ (BUY) จาก schema ใหม่
  // const buyMaterials =
  //   data[0]?.materials?.filter((item) => item.transaction_type === 'BUY') || [];
  console.log('data', data);

  const TableHeader = () => (
    <thead className="bg-red-600">
      <tr>
        <th className="px-4 py-3 text-left text-sm font-bold text-white border-r border-red-700">
          รายการสินค้า
        </th>
        <th className="px-4 py-3 text-center text-sm font-bold text-white border-r border-red-700">
          ประเภท
        </th>
        {data?.materials?.some((item) => item?.place !== 'คลังอื่นๆ') ? (
          <th className="px-4 py-3 text-center text-sm font-bold text-white border-r border-red-700">
            น้ำหนักซื้อ
          </th>
        ) : (
          <th className="px-4 py-3 text-center text-sm font-bold text-white border-r border-red-700">
            จำนวนชิ้น
          </th>
        )}
        <th className="px-4 py-3 text-center text-sm font-bold text-white">
          มูลค่าซื้อก่อนภาษี
        </th>
        <th className="px-4 py-3 text-center text-sm font-bold text-white border-r border-red-700">
          ภาษี VAT
          <br />
          (บาท)
        </th>
        <th className="px-4 py-3 text-center text-sm font-bold text-white border-r border-red-700">
          มูลค่าเฉลี่ย
          <br />
          ต่อบาท
        </th>
        <th className="px-4 py-3 text-center text-sm font-bold text-white">
          มูลค่าซื้อรวมภาษี
        </th>
      </tr>
    </thead>
  );

  const TableRows = ({ materials }) => (
    <tbody>
      {_.chain(materials)
        .sortBy((item) => {
          // 2. อัปเดตฟิลด์สำหรับเรียงลำดับ
          const productTypeName = item?.product_type || '';
          return productTypeName === '96.5%' ? '0' : `1_${productTypeName}`;
        })
        // 3. อัปเดตฟิลด์สำหรับจัดกลุ่ม
        .groupBy((item) => item?.product_name + (item?.product_type || ''))
        .map((group) => {
          // 4. อัปเดตฟิลด์ในการคำนวณค่ารวม
          const sumWeight = _.sumBy(group, (g) => Number(g?.totalWeight) || 0);
          const sumCostbeforeVat = _.sumBy(
            group,
            (g) => Number(g?.totalBeforeVat) || 0, // แก้ไขชื่อฟิลด์เป็น totalBeforeVat (B ตัวใหญ่)
          );
          // ใช้ totalValue สำหรับยอดรวมภาษี
          const sumTotalValue = _.sumBy(
            group,
            (g) => Number(g?.totalValue) || 0,
          );
          const sumVat = _.sumBy(group, (g) => Number(g.totalVat) || 0);

          const item = group[0];

          // (Optional) หากยังต้องการใช้ค่าเฉลี่ย ให้ปรับตามนี้
          const averageCost =
            sumWeight > 0
              ? item?.product_type === 'ทองแท่ง'
                ? (sumCostbeforeVat / sumWeight) * 15.244
                : (sumCostbeforeVat / sumWeight) * 15.16
              : 0;
          console.log('material', materials);
          const productName = item?.product_name?.trim();
          return (
            <tr key={item?.product_name + (item?.product_type || '')}>
              <td className="px-4 py-2 text-sm text-gray-800 border-r border-gray-200">
                {/* 5. อัปเดตฟิลด์ที่แสดงผล */}
                {item?.product_name || '-'}
              </td>
              <td className="px-4 py-2 text-sm text-gray-800 text-center border-r border-gray-200">
                {item?.product_type || '-'}
              </td>
              <td className="px-4 py-2 text-sm text-gray-800 text-center border-r border-gray-200">
                {item?.isbar || ['ทองคำแท่ง', 'ทองแท่ง'].includes(productName)
                  ? sumWeight?.toLocaleString(undefined, {
                      minimumFractionDigits: 3,
                      maximumFractionDigits: 3,
                    }) || '-'
                  : sumWeight?.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) || '-'}
              </td>
              <td className="px-4 py-2 text-sm text-gray-800 text-center border-r border-gray-200">
                {sumCostbeforeVat
                  ? Number(sumCostbeforeVat?.toFixed(2)).toLocaleString()
                  : '-'}
              </td>
              <td className="px-4 py-2 text-sm text-gray-800 text-center border-r border-gray-200">
                {sumVat ? Number(sumVat).toLocaleString() : '0'}
              </td>
              <td className="px-4 py-2 text-sm text-gray-800 text-center border-r border-gray-200">
                {averageCost ? Number(averageCost).toLocaleString() : '-'}
              </td>
              <td className="px-4 py-2 text-sm text-gray-800 text-center border-r border-gray-200">
                {sumTotalValue
                  ? Number(sumTotalValue?.toFixed(2)).toLocaleString()
                  : '-'}
              </td>
            </tr>
          );
        })
        .value()}
    </tbody>
  );

  return (
    <div className="space-y-6">
      {/* 6. ใช้ข้อมูลที่กรองแล้ว (buyMaterials) */}
      {_.chain(data?.materials || [])
        .groupBy('place')
        .toPairs()
        .sortBy(([place]) =>
          place === 'คลังรูปพรรณใหม่' ? '0' : `1_${place || 'ไม่ระบุคลัง'}`,
        )
        .map(([place, materials]) => (
          <div
            key={place}
            className="bg-white rounded-lg shadow-sm overflow-hidden"
          >
            <div className="bg-gray-50 px-4 py-2 border-b">
              <h3 className="text-lg font-semibold text-gray-800">
                {place || 'ไม่ระบุคลัง'}
              </h3>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full">
                <TableHeader />
                <TableRows materials={materials} />
              </table>
            </div>
          </div>
        ))
        .value()}
    </div>
  );
};

export default PurchaseStockTable;
